import React, { useEffect, useRef, useState } from 'react';
import './form-sales.scss'
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from 'react-hook-form';
import { useStaticQuery, graphql } from "gatsby"
import Input from '../../../shared/components/atoms/input/input';
import InputCheck from '../../../shared/components/atoms/input-check/input-check';
import emailIcon from '../../../shared/assets/images/icons/email.svg'
import phoneIcon from '../../../shared/assets/images/icons/phone.svg'
import cellphoneIcon from '../../../shared/assets/images/icons/cellphone.svg'
import Button from '../../../shared/components/atoms/button/button'
import NotificationServices from '../../../shared/services/notification-services';
import siteUrl from '../../../shared/utils/siteUrl';

const FormSales = props => {
    const { slug, setactiveView, nombre, tipoDeBien,modalidadDeCompra } = props

    const { contentfulInformacionGeneral } = useStaticQuery(graphql`
      {
        contentfulInformacionGeneral {
          mostrarTelfonoFijo
          tycBienesEnVenta
        }
      }
    `)

    const { mostrarTelfonoFijo, tycBienesEnVenta } = contentfulInformacionGeneral

    const { register, handleSubmit, errors, formState } = useForm({
        mode: 'onBlur',
    });

    const EMAIL_RX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

    const [valueTYC, setvalueTYC] = useState(true)
    const [disabledButton, setdisabledButton] = useState(false)

    const [tycError, settycError] = useState(false)

    const recaptchaRef = useRef(null);

    useEffect(() => {
        recaptchaRef.current.execute()
    }, [])

    const onSubmit = e => {
        if (!haveErrors()) {
            setdisabledButton(true)

            let splittedName = e.nombres.split(' ')
            let splittedLastname = e.apellidos.split(' ')

            let tipoActivo = modalidadDeCompra === null ? 'Vehiculo' :
                 modalidadDeCompra.nombreTab === 'BamHogar' ? 'BamHogar' : 'ActivoExtraoridinario'
 
            let payload = {
                firstName: splittedName[0],
                secondName: splittedName[1] ? splittedName[1] : '',
                surname: splittedLastname[0],
                secondSurname: splittedLastname[1] ? splittedLastname[1] : '',    
                identification: e.numeroIdentificacion,
                email: e['correo-electronico'],
                cellphone: e['telefono-celular'],
                phone: e.telefono,
                gRecaptchaResponse: recaptchaRef.current.getValue(),
                isCustomer: '',
                detail: e.detalle,
                formType: "BienesEnVenta",
                tipoActivo: tipoActivo,
                motivation: `Solicitud de ${tipoDeBien} - ${nombre}`,
                productName: nombre,
                productType: tipoDeBien,
                slug: slug
            };

            NotificationServices.sendNotification(payload).then(
                response => {
                    if (response.status === 200) {
                        setactiveView('ty');
                        setdisabledButton(false)
                    } else {
                        setdisabledButton(false)
                        window.location.href = siteUrl + '/503/'
                    }
                }
            ).catch(error => {
                console.error(error)
                window.location.href = siteUrl + '/503/'
            });
        }
    }

    const haveErrors = () => {
        if (!valueTYC) {
            settycError('Selecciona una opción')
        } else {
            settycError(false)
        }

        return (!valueTYC)
    }

    return (
        <div className="o-form-sales-container">
            <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={process.env.CAPTCHA_KEY}
            />
            <form className="o-form-sales" onSubmit={handleSubmit(onSubmit)}>
                <h2 className="o-sub-title-form custom-h h4">Solicitud de información</h2>
                <br></br>
                <br></br>
                <div className="o-form-contact-row">
                    <div className="o-form-contact-row-input">
                        <Input
                            label="Nombres"
                            errors={errors}
                            id="o-name-input"
                            name="nombres"
                            type="text"
                            register={register({
                                required: { value: true, message: "Este campo es requerido." },
                            })}
                        />
                    </div>
                    <div className="o-form-contact-row-separator"></div>
                    <div className="o-form-contact-row-input">
                        <Input
                            label="Apellidos"
                            errors={errors}
                            id="o-lastname-input"
                            name="apellidos"
                            type="text"
                            register={register({
                                required: { value: true, message: "Este campo es requerido." },
                            })}
                        />
                    </div>
                </div>
                <div className="o-form-contact-row">
                    <div className="o-form-contact-row-input">
                        <Input
                            label="Teléfono celular"
                            errors={errors}
                            id="o-cellphone-input"
                            name="telefono-celular"
                            type="number"
                            icon={cellphoneIcon}
                            register={register({
                                required: { value: true, message: "Este campo es requerido." },
                                min: { value: 9999999, message: "El teléfono debe ser de 8 dígitos" },
                                max: { value: 99999999, message: "El teléfono debe ser de 8 dígitos" },
                                // pattern: { value: /^[2-6].*/, message: "Teléfono inválido" }
                            })}
                        />
                    </div>
                    <div className="o-form-contact-row-separator"></div>
                    {mostrarTelfonoFijo ?
                        <div className="o-form-contact-row-input">
                            <Input
                                label="Teléfono fijo"
                                errors={errors}
                                id="o-phone-input"
                                name="telefono"
                                type="number"
                                icon={phoneIcon}
                                register={register({
                                    // required: { value: true, message: "Este campo es requerido." },
                                    min: { value: 9999999, message: "El teléfono debe ser de 8 dígitos" },
                                    max: { value: 99999999, message: "El teléfono debe ser de 8 dígitos" },
                                    // pattern: { value: /^[2-6].*/, message: "Teléfono inválido" }
                                })}
                            />
                        </div>
                        :
                        <div className="o-form-contact-row-no-input"></div>
                    }
                </div>
                <div className="o-form-contact-row">
                    <div className="o-form-contact-row-input">
                        <Input
                            label="Correo electrónico"
                            errors={errors}
                            id="o-email-input"
                            name="correo-electronico"
                            type="text"
                            icon={emailIcon}
                            register={register({
                                required: { value: true, message: "Este campo es requerido." },
                                pattern: { value: EMAIL_RX, message: "Correo electrónico inválido" }
                            })}
                        />
                    </div>
                    <div className="o-form-contact-row-separator"></div>
                    <div className="o-form-contact-row-no-input"></div>
                </div>
                <Input
                    label="Escribe aquí"
                    type='textarea'
                    errors={errors}
                    id="o-more-details-input"
                    name="detalle"
                    maxLength={500}
                    register={register({
                        required: { value: true, message: "Este campo es requerido." },
                        maxLength: { value: 500, message: "El mensaje debe ser mas corto" },
                        minLength: { value: 10, message: "El mensaje debe ser mas largo" },
                    })}
                />
                <InputCheck
                    label='Autorizo a BAM para que el número celular y el correo electrónico, sean tratados para contactarme y/o enviarme la información de la solicitud del producto. Igualmente para que me consulten ante Operadores de información y Riesgo con el fin de verificar mi información personal.'
                    active={valueTYC}
                    setActive={setvalueTYC}
                    error={tycError}
                />

                <a className="o-tyc-redirect" href={tycBienesEnVenta} target={'_blank'} rel="noopener noreferrer">
                    Términos, Condiciones y Políticas de Privacidad para la solicitud de productos.
                </a>
                <br></br>
                <br></br>
                <br></br>
                <div className="o-form-contact-button-position">
                    <div className="o-form-contact-button-container">
                        <Button
                            disabled={!formState.isValid || disabledButton}
                            title='ENVIAR'
                            className='full'
                        />
                    </div>
                </div>
            </form>
        </div>
    )
}

export default FormSales
